/**
 * 该文件存放资质管理相关页面路由
 */

const qualificationManageRoutes = [
  {
    path: '/',
    component: () => import('@/homepage'),
    children: [
      // 首营资料设置，仅供应商端有
      {
        path: '/credentials-manage',
        name: 'CredentialsManage',
        meta: {
          menuName: 'qualification-config'
        },
        component: () => import('@/pages/credentials/firstcamp-setting')
      },
      {
        path: '/add-seal-confirm',
        name: 'AddSealConfirm',
        meta: {
          menuName: 'qualification-config'
        },
        component: () => import('@/pages/credentials/firstcamp-setting/add-seal-confirm.vue')
      },
      // 我的企业资质
      {
        path: '/company-credentials',
        name: 'CompanyCredentials',
        meta: {
          menuName: 'qualification-company'
        },
        component: () => import('@/pages/credentials/my-company-qualification')
      },
      // 修改企业信息页面
      {
        path: '/update-company-info',
        name: 'UpdateCompanyInfo',
        meta: {
          menuName: ''
        },
        component: () => import('@/pages/credentials/update-company')
      },
      // 我的协议
      {
        path: '/business-agreement',
        name: 'businessAgreement',
        meta: {
          menuName: 'qualification-agreement'
        },
        component: () => import('@/pages/agreement')
      },
      // 我的协议-签章确认
      {
        path: '/sign-confirm',
        name: 'signConfirm',
        meta: {
        },
        component: () => import('@/pages/agreement/signConfirm')
      },
      // 我的品种资质
      {
        path: '/credentials-product',
        name: 'CredentialsProduct',
        meta: {
          menuName: 'qualification-product'
        },
        component: () => import('@/pages/credentials/product/product')
      },
      // 我的品种资质-添加/编辑品种
      {
        path: '/product-info/:id?',
        name: 'ProductInfo',
        meta: {
          menuName: 'qualification-product'
        },
        component: () => import('@/pages/credentials/product-info')
      },
      // 资质文字信息编辑
      {
        path: '/credentials-editor',
        name: 'EditCredentials',
        component: () => import('@/pages/credentials/textEditor/textEditor')
      },
    ]
  }
];

export default qualificationManageRoutes;
